"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var chrome_os_tcp_client_1 = __importStar(require("@rbi-ctg/chrome-os-tcp-client"));

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");
/**
 * Internal Observable wrapper for the chrome-os socket client
 */


var ObservableClient =
/** @class */
function () {
  function ObservableClient(host, port) {
    this.host = host;
    this.port = port;
    this.client = new chrome_os_tcp_client_1.default(host, port);
    this.observable = new rxjs_1.Subject();
  }
  /**
   * Start the socket connection
   * @returns {Promise<void>}
   */


  ObservableClient.prototype.connect = function () {
    return this.client.connect();
  };
  /**
   * create observable event listeners for
   * client, merge and subscribe to combined
   * observable.
   * @param {Observer<T>} observer an observer object for handling
   * "data", "error" and "close" events from the client, which are
   * mapped to next, error, and complete methods on the input
   * observer
   *
   * @returns {{ unsubscribe(): void }} an unsubscribe function
   * for cleaning up the client connection
   */


  ObservableClient.prototype.subscribe = function (observer) {
    var onDataObservable = rxjs_1.fromEvent(this.client, chrome_os_tcp_client_1.ClientEventType.DATA);
    var onErrorObservable = rxjs_1.fromEvent(this.client, chrome_os_tcp_client_1.ClientEventType.ERROR).pipe(operators_1.flatMap(function (error) {
      return rxjs_1.throwError(error);
    }));
    var onCloseObservable = rxjs_1.fromEvent(this.client, chrome_os_tcp_client_1.ClientEventType.CLOSE);
    var combined = rxjs_1.merge(onDataObservable, onErrorObservable).pipe(operators_1.takeUntil(onCloseObservable));
    this.subscription = combined.subscribe(this.observable);
    var consumerSubscription = this.observable.subscribe(observer).add(this.subscription).add(this.close.bind(this));
    return consumerSubscription;
  };

  ObservableClient.prototype.pipe = function () {
    var _a;

    var operators = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      operators[_i] = arguments[_i];
    }

    this.observable = (_a = this.observable).pipe.apply(_a, operators);
    return this;
  };
  /**
   * write a buffer to the underlying client
   * @param {Buffer} data the data to send over the socket connection
   *
   * @returns {Promise<void>}
   */


  ObservableClient.prototype.write = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.client.write(data)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * internal unsubscribe helper
   */


  ObservableClient.prototype.close = function () {
    this.client.close();
  };

  return ObservableClient;
}();

exports.default = ObservableClient;